import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';
import { calculateSharedRoutes } from '@shared/lib/shared.routes';
import { authenticatedSsoCanActivate } from '@usana/ux/sso-auth';

const BAOYING_ROUTES: Route[] = [
  {
    path: 'account',
    canActivate: [authenticatedSsoCanActivate],
    loadChildren: () => import('./lazy-modules/account/baoying-account.module').then((m) => m.BaoyingAccountModule),
  },
  {
    path: 'forgot',
    loadChildren: () => import('./lazy-modules/forgot/baoying-forgot.module').then((m) => m.BaoyingForgotModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot([], { useHash: false }), RouterModule.forChild(calculateSharedRoutes(BAOYING_ROUTES))],
  exports: [RouterModule],
  providers: [],
})
export class BaoyingRoutingModule {}
